import { render, staticRenderFns } from "./IbxPreviewGroups.vue?vue&type=template&id=20808337"
import script from "./IbxPreviewGroups.vue?vue&type=script&lang=js"
export * from "./IbxPreviewGroups.vue?vue&type=script&lang=js"
import style0 from "./IbxPreviewGroups.vue?vue&type=style&index=0&id=20808337&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports